import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import app from './app';

// Pages
const Home = () => import(/* webpackChunkName: "Home" */'./pages/Home.vue');
const Games = () => import(/* webpackChunkName: "Games" */'./pages/Games.vue');

const News = () => import(/* webpackChunkName: "News" */'./pages/News.vue');
const NewsArticle = () => import(/* webpackChunkName: "NewsArticle" */'./pages/NewsArticle.vue');

const Casinos = () => import(/* webpackChunkName: "Casinos" */'./pages/Casinos.vue');
const Suppliers = () => import(/* webpackChunkName: "Suppliers" */'./pages/Suppliers.vue');

const User = () => import(/* webpackChunkName: "User" */'./pages/User.vue');
const UserFavouriteCasinos = () => import(/* webpackChunkName: "UserFavouriteCasinos" */'./pages/UserFavouriteCasinos.vue');
const UserFavouriteGames = () => import(/* webpackChunkName: "UserFavouriteGames" */'./pages/UserFavouriteGames.vue');
const UserFavouriteOffers = () => import(/* webpackChunkName: "UserFavouriteOffers" */'./pages/UserFavouriteOffers.vue');
const UserFavouriteSuppliers = () => import(/* webpackChunkName: "UserFavouriteSuppliers" */'./pages/UserFavouriteSuppliers.vue');

const Map = () => import(/* webpackChunkName: "Map" */'./pages/Map.vue');

const Offers = () => import(/* webpackChunkName: "Offers" */'./pages/Offers.vue');

import RouteHandler from './pages/RouteHandler.vue';
const NotFound = () => import(/* webpackChunkName: "NotFound" */'./pages/NotFound.vue');

// Translated Pages
const TermsAndConditions = () => import(/* webpackChunkName: "TermsAndConditions" */'./pages/' + Laravel.locale + '/TermsAndConditions.vue');
const PrivacyPolicy = () => import(/* webpackChunkName: "PrivacyPolicy" */'./pages/' + Laravel.locale + '/PrivacyPolicy.vue');

const Router = {
  base: '/',
  mode: 'history',
  routes: [
    // Regular page routes
    { path: '/', name: 'Home', component: Home },
    { path: '/news', name: 'News', component: News },
    { path: '/news/:slug', name: 'News Article', component: NewsArticle, props: true },
    { path: '/casinos', name: 'Casinos', component: Casinos },
    { path: '/casinos/:slug', name: 'Casino', component: RouteHandler, props: true },
    { path: '/terms-and-conditions', name: 'Terms and Conditions', component: TermsAndConditions },
    { path: '/privacy-policy', name: 'Privacy Policy', component: PrivacyPolicy },
    { path: '/city/:slug?', name: 'City', component: Map, props: true },
    { path: '/user', component: User,
      children: [
        { path: 'favourites/casinos', component: UserFavouriteCasinos },
        { path: 'favourites/games', component: UserFavouriteGames },
        { path: 'favourites/offers', component: UserFavouriteOffers },
        { path: 'favourites/game-studios', component: UserFavouriteSuppliers }
      ]
    },
    { path: '/games', name: 'Games', component: Games },
    { path: '/play/:slug', name: 'Play', component: RouteHandler, props: true },
    { path: '/offers', name: 'Offers', component: Offers },
    { path: '/offers/:slug', name: 'Offer', component: RouteHandler, props: true },
    { path: '/game-studios', name: 'Suppliers', component: Suppliers },
    { path: '/game-studios/:slug', name: 'Supplier', component: RouteHandler, props: true },

    // 301 Redirects
    { path: '/casinos/:slug/*', redirect: '/casinos/:slug'},
    { path: '/casinos/*/news', redirect: '/news'},
    { path: '/casinos/*/news/:slug', redirect: '/news/:slug'},

    { path: '/game-creators', redirect: '/game-studios'},
    { path: '/game-creators/:slug', redirect: '/game-studios/:slug'},
    { path: '/user/favourites/game-creators', redirect: '/user/favourites/game-studios'},

    // 404 page
    { path: '*', name: 'Not Found', component: NotFound },
  ],

  linkActiveClass: 'is-active',

  scrollBehavior (to, from, savedPosition) {
    const position = {};

    if (savedPosition) {
      position.x = savedPosition.x;
      position.y = savedPosition.y;
    } else {
      position.x = 0;
      position.y = 0;
    }

    // If technically routing to the same page
    if (from.matched[0].path === to.matched[0].path) {
      // When scrollToSelector meta is used
      // limited to small screens
      if (to.matched.some(m => m.meta.scrollToSelector) && app.$mq('sm-max')) {
        return {
          selector: to.meta.scrollToSelector,
          offset: { x: 0, y: 65 }
        }
      } else {
        return position;
      }
    }

    return new Promise(resolve => {
      app.$root.$once('scrollBeforeEnter', () => {
        resolve(position);
      });
    });
  }
};

// Add a sandbox route as a development playground
if (process.env.NODE_ENV === 'development') {
  Router.routes.push({ path: '/sandbox', name: 'Sandbox', component: require('@/pages/Sandbox.vue').default });
}

export default new VueRouter(Router);


// WEBPACK FOOTER //
// ./resources/assets/js/app/router.js